import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionShell, SectionTitle } from '../SectionShell';
import { CTAButton } from '../CTAButton';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <SectionShell tone="darker" data-id="element-113" data-mp="1clz9obpw4bzq">
      <SectionTitle eyebrow="🎁 Free with your order" title="5 exclusive bonuses — free" subtitle="Get these 5 bonuses included today · Total bonus value: $197" data-id="element-114" data-mp="1citmj20tnk6n" />

      <div className="space-y-6" data-id="element-115" data-mp="257r22xdnf2vp">
        {bonuses.map(bonus => <article key={bonus.label} className="overflow-hidden rounded-2xl border border-gold-500/25 bg-navy-900" data-id="element-116" data-mp="20ba5desdvg70">
            <img src={bonus.image} alt={`${bonus.title} product mockup`} className="block w-full bg-white" data-id="element-117" data-mp="1racablzxaj0k" />
            <div className="p-5" data-id="element-118" data-mp="kvbedgawe0tz">
              <div className="flex flex-wrap items-center gap-2" data-id="element-119" data-mp="fv6v5iilus02">
                <span className="rounded-md bg-gold-500 px-2.5 py-1 font-display text-[11px] uppercase tracking-[0.15em] text-navy-950" data-id="element-120" data-mp="fx03r3cs3map">
                  {bonus.label}
                </span>
                <span className="rounded-md border border-gold-500/50 px-2.5 py-1 font-display text-[11px] uppercase tracking-[0.15em] text-gold-400" data-id="element-121" data-mp="1jrykagobvi3y">
                  {bonus.value}
                </span>
              </div>

              <h3 className="mt-3 font-display text-xl leading-tight text-white sm:text-2xl" data-id="element-122" data-mp="w35meeo5b06p">
                {bonus.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-sky-100/75" data-id="element-123" data-mp="10uxcyp7ax5wu">{bonus.description}</p>

              {bonus.listLabel && !bonus.items && <p className="mt-3 rounded-lg bg-navy-800 px-3 py-2.5 font-display text-[11px] uppercase leading-relaxed tracking-wide text-sky-300 sm:text-xs" data-id="element-124" data-mp="n0o1q4o52flt">
                  {bonus.listLabel}
                </p>}

              {bonus.items && <>
                  {bonus.listLabel && <p className="mt-4 text-[11px] font-bold uppercase tracking-[0.15em] text-sky-400" data-id="element-125" data-mp="2jt3brtfwlvts">
                      {bonus.listLabel}
                    </p>}
                  <ul className="mt-2 grid gap-1.5 sm:grid-cols-2" data-id="element-126" data-mp="2b003s0o12b6j">
                    {bonus.items.map(item => <li key={item} className="flex items-start gap-2 text-sm text-sky-100/85" data-id="element-127" data-mp="261ye2ww3jdm3">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" aria-hidden="true" data-id="element-128" data-mp="32rpibnu6wf53" />
                        <span data-id="element-129" data-mp="2tq8307olwhhg">{item}</span>
                      </li>)}
                  </ul>
                </>}

              {bonus.footer && <p className="mt-3 text-sm italic text-sky-100/60" data-id="element-130" data-mp="1ibktfrfuch1j">{bonus.footer}</p>}
            </div>
          </article>)}
      </div>

      <div className="mt-8" data-id="element-131" data-mp="1dawt2f5q2nun">
        <CTAButton label="Get all 5 bonuses free" subline="Included today with your $27 order" data-id="element-132" data-mp="1deucz304jjfl" />
      </div>
    </SectionShell>;
}